module.exports = __webpack_public_path__ + "static/media/illo-globe.ca0975fb.png";